"use strict";
/**
 * This function is used to get the difference between two arrays while avoiding duplicate removal.
 *
 * @param {Array} itemsToPullFrom - an array of items that we want to pull from
 * @param {Array} pulledItems - an array of items to pull out
 * @returns {Array} - original array reduced by pulled items
 * @example
 * getDifferenceConsideringDuplicates([0, 0, 0], [0, 0]) // returns [0] (more examples in test)
 *
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifferenceConsideringDuplicates = void 0;
const getDifferenceConsideringDuplicates = (itemsToPullFrom, pulledItems) => {
    const copiedPulledItems = pulledItems.slice();
    const result = itemsToPullFrom.filter((item) => {
        const pulledItemIndex = copiedPulledItems.findIndex((itpc) => itpc === item);
        if (pulledItemIndex > -1) {
            copiedPulledItems.splice(pulledItemIndex, 1);
        }
        return pulledItemIndex === -1;
    });
    return result;
};
exports.getDifferenceConsideringDuplicates = getDifferenceConsideringDuplicates;
//# sourceMappingURL=getDifferenceConsideringDuplicates.js.map